export function getHash() {
    return process.env.REACT_APP_HASH || process.env.NODE_ENV;
}
export function getVersion() {
    return process.env.REACT_APP_VERSION || '0.0.0';
}
//# sourceMappingURL=env.js.map